(function () {
	function initJklPdpGallery() {
		const gallery = document.querySelector("[data-jkl-pdp-gallery]");
		if (!gallery) return;
		const stage = gallery.querySelector("[data-jkl-pdp-stage]");
		const mainImg = stage && stage.querySelector("img");
		if (!mainImg) return;

		gallery.querySelectorAll("[data-jkl-pdp-thumb]").forEach((btn) => {
			btn.addEventListener("click", (e) => {
				e.preventDefault();
				const src = btn.getAttribute("data-main-src");
				if (!src) return;
				gallery
					.querySelectorAll("[data-jkl-pdp-thumb]")
					.forEach((t) => t.classList.remove("is-active"));
				btn.classList.add("is-active");
				mainImg.src = src;
				mainImg.removeAttribute("srcset");
				mainImg.removeAttribute("sizes");
			});
		});
	}

	document.addEventListener("DOMContentLoaded", initJklPdpGallery);
	document.addEventListener("shopify:section:load", initJklPdpGallery);
})();
